export default {


    async removeGroup(context, payload) {
        console.log('payload in removeGroup', payload)
        const token = context.rootGetters.token;
        const group = context.getters.groups.find(g => g.id === payload.id);


        const response = await fetch(`https://trackingmembers-a1654-default-rtdb.firebaseio.com/groups/${group.id}.json?auth=` + token, {
            method: 'DELETE'
        });

        const responseData = await response.json();
        if (!response.ok) {
            const error = new Error(responseData.message || 'Failed to send request');
            throw error;
        }
        context.commit('removeAgroup', group);
    },

    async removeNote(context, payload) {
        console.log('removeNote', payload)
        const token = context.rootGetters.token;
        const group = context.getters.groups.find(g => g.id === payload.id);
        console.log('group notes', group.notes)

        await fetch(`https://trackingmembers-a1654-default-rtdb.firebaseio.com/groups/${group.id}/notes/${payload.noteId}.json?auth=` + token, {
            method: 'DELETE'
        });
        context.commit('removeNote', payload);
    },




    async addToGroupAction(context, payload) {
        console.log('user id id id', payload.id)
        const group = context.getters.groups.find(g => g.id === payload.groupId);
        const member = {
            id: payload.id,
            firstName: payload.firstName,
            lastName: payload.lastName
        }

        if (group.members === undefined) {
            group.members = new Array();
        }

        const token = context.rootGetters.token;

        group.members.push(member)
        const response = await fetch(`https://trackingmembers-a1654-default-rtdb.firebaseio.com/groups/${group.id}.json?auth=` + token, {
            method: 'PATCH',
            body: JSON.stringify({
                groupName: group.groupName,
                groupLeader: group.groupLeader,
                members: group.members,
                notes: group.notes
            })
        });
        const responseData = await response.json();
        if (!response.ok) {
            const error = new Error(responseData.message || 'Failed to send request');
            throw error;
        }
        // send a request to members and add the group to members
        const res = await fetch(`https://trackingmembers-a1654-default-rtdb.firebaseio.com/members/${member.id}.json?auth=` + token, {
            method: 'PATCH',
            body: JSON.stringify({
                connectionGroup: {
                    groupId: group.id,
                    groupName: group.groupName,
                    groupLeader: group.groupLeader
                }
            })
        });
        const resData = await res.json();
        if (!res.ok) {
            const error = new Error(resData.message || 'Failed to send request');
            throw error;
        }

        context.commit('addToGroup', member);
    },

    async addNote(context, data) {

        const group = context.getters.groups.find(g => g.id === data.id);
        const token = context.rootGetters.token;

        const response = await fetch(`https://trackingmembers-a1654-default-rtdb.firebaseio.com/groups/${group.id}/notes.json?auth=` + token, {
            method: 'POST',
            body: JSON.stringify({
                note: data.note
            })
        });

        const responseData = await response.json();
        if (!response.ok) {
            const error = new Error(responseData.message || 'Failed to fetch!');
            throw error;
        }

        const payload = {
            groupId: group.id,
            id: responseData.name,
            note: data.note
        }

        context.commit('addNoteToGroup', payload);

    },

    async removeFromGroup(context, data) {

        //get the group change the members array and send the whole new array to fireBase
        const groups = context.getters.groups
        const group = groups.find(group => group.id === data.id)

        let members = []
        if (group.members) {
            members = group.members.filter(member => member.id != data.memberId)
        }

        const token = context.rootGetters.token;
        const response = await fetch(`https://trackingmembers-a1654-default-rtdb.firebaseio.com/groups/${data.id}/.json?auth=` + token, {
            method: 'PATCH',
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify({

                members

            })
        });

        const responseData = await response.json();
        if (!response.ok) {
            const error = new Error(responseData.message || 'Failed to fetch!');
            throw error;
        }

        context.commit('removeFromGroup', data);
    },

    registerGroup(context, data) {
        context.commit('registerGroup', data);
    },

    async fetchGroups(context) {

        const res = await fetch('https://trackingmembers-a1654-default-rtdb.firebaseio.com/groups.json');
        const resData = await res.json();
        if (!res.ok) {
            const error = new Error(resData.message || 'Failed ot fetch');
            throw error;
        }

        const groups = []
        for (const key in resData) {
            const group = {
                id: key,
                groupName: resData[key].groupName,
                groupLeader: resData[key].groupLeader,
                members: resData[key].members,
                notes: resData[key].notes
            };
            const notesToIterAte = group.notes
            let newNotes = []
            for (const key in notesToIterAte) {
                const note = {
                    id: key,
                    note: notesToIterAte[key].note
                }
                newNotes.push(note)
                group.notes = newNotes;
            }

            groups.push(group)
        }
        context.commit('setGroups', groups);
    }

}